/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_SOFT,
  BUTTON_THEME_DEFAULT,
  Button,
  ICON_LOCAL_OFFER,
  ICON_REFRESH,
  ICON_TEXT_FIELDS,
} from '@squiz/sds';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MONITORING_STRINGS } from '../../../../Constants/Strings.constants';
import { LogsQuery } from '../../Logs.constants';
import { FilterByDatetime } from '../FilterByDatetime/FilterByDatetime';
import { FilterByText } from '../FilterByText/FilterByText';
import { SelectPresetTime } from '../SelectPresetTime/SelectPresetTime';
import { LOGS_FILTER_DATA_IDS } from './LogsFilter.constants';
import { LogsFilterProps } from './LogsFilter.props';

/**
 * Contains sub-components to filter or refresh the results.
 */
export const LogsFilter = (props: LogsFilterProps): JSX.Element => {
  const { t } = useTranslation();
  const { setRefresh } = props;

  // Labels
  const labels = useMemo(() => {
    return {
      refreshLogs: t(MONITORING_STRINGS.refreshLogs),
      searchLogs: t(MONITORING_STRINGS.searchLogs),
      searchTags: t(MONITORING_STRINGS.searchTags),
    };
  }, [t]);

  const refreshButton = useMemo((): JSX.Element => {
    return (
      <Button
        classes="logs__load-button"
        dataId={LOGS_FILTER_DATA_IDS.refreshButton}
        format={BUTTON_FORMAT_SOFT}
        icon={ICON_REFRESH}
        onClick={(): void => setRefresh(true)}
        text={labels.refreshLogs}
        theme={BUTTON_THEME_DEFAULT}
      />
    );
  }, [labels, setRefresh]);

  return (
    <div className="logs__filter" data-id={LOGS_FILTER_DATA_IDS.searchBar}>
      <div className="logs__select-time">
        <SelectPresetTime />
      </div>
      <FilterByDatetime />
      <div className="logs__load-button-wrapper">{refreshButton}</div>
      <div className="logs__text-filter">
        <FilterByText icon={ICON_LOCAL_OFFER} placeholderText={labels.searchTags} queryParam={LogsQuery.filter.tag} />
      </div>
      <div className="logs__text-filter">
        <FilterByText icon={ICON_TEXT_FIELDS} placeholderText={labels.searchLogs} queryParam={LogsQuery.filter.query} />
      </div>
    </div>
  );
};
